import {departmentCenters} from './departmentCenters.js';

const zipInputEls = document.querySelectorAll('.mksun-input-zip');
const testZip = (zip) => {
    return /^([0-8]\d{4}|2[AB]\d{3}|9\d{4})$/.test(zip);

};

zipInputEls.forEach((zipInputEl) => {
    const inputZip = zipInputEl.querySelector('input');
    const submitZip = zipInputEl.querySelector('.btn')


    const submitCb = async (e) => {
        e.preventDefault();
        // remove all spaces and unbreakable spaces etc. from the input
        inputZip.value = inputZip.value.replace(/\s/g, '');
        if (testZip(inputZip.value)) {
            if(localStorage?.main != null) {
                let main = JSON.parse(localStorage.main);
                main.userLocation = {
                    postalCode: inputZip.value,
                    departmentCenterCoordinates: departmentCenters[inputZip.value.substring(0, 2)]
                };
                main.displayPauseOverlay = false;
                await localStorage.setItem('main', JSON.stringify(main));
            } else {
                await localStorage.setItem('main', JSON.stringify({
                    userLocation: {
                        postalCode: inputZip.value,
                        departmentCenterCoordinates: departmentCenters[inputZip.value.substring(0, 2)]
                    },
                    displayPauseOverlay: false
                }));
            }
            if(window.origin.includes('monkitsolaire.fr')) {
                window.location.href = '/mk-sun/configurateur';
            } else {
                window.location = 'https://www.monkitsolaire.fr/mk-sun/configurateur?zipcode=' + inputZip.value;
            }
        } else {
            window.alert('Code postal invalide, veuillez entrer un code postal valide sans lettres');
        }
    }

    submitZip.addEventListener('click', (e) => {
        submitCb(e);
    });

    inputZip.addEventListener('keydown', (e) => {
        if(e.key === 'Enter') {
            submitCb(e);
        }
    });
})

const skipZipEls = document.querySelectorAll('.mksun-skip-zip');


skipZipEls.forEach((skipZip) => {
skipZip.addEventListener('click', async (e) => {
    e.preventDefault();
    if(localStorage?.main == null) {
        await localStorage.setItem('main', JSON.stringify({
            userLocation: {
                postalCode: 'skip',
                departmentCenterCoordinates: departmentCenters['skip']
            },
            displayPauseOverlay: false
        }));
    } else if(JSON.parse(localStorage?.main)?.userLocation === null) {
        let main = JSON.parse(localStorage.main);
        main.userLocation = {
            postalCode: '75000',
            departmentCenterCoordinates: {
                lat: 48.8566,
                lng: 2.3522
            }
        };
        main.displayPauseOverlay = false
        await localStorage.setItem('main', JSON.stringify(main));
    }

    if(window.origin.includes('monkitsolaire.fr')) {
        window.location.href = '/mk-sun/configurateur';
    } else {
        window.location = 'https://www.monkitsolaire.fr/mk-sun/configurateur';
    }
})});